import { post } from '@/utils/request'

// 获取老兵列表
export function getLeifengList(data) {
  return post('admin/commodity/getLeifengList', data)
}

// 获取老兵详情
export function getLeifengDetail(data) {
  return post('admin/commodity/getLeifengDetail', data)
}

// 审核通过
export function auditLeifengPass(data) {
  return post('admin/commodity/auditLeifengPass', data)
}

// 审核拒绝
export function auditLeifengReject(data) {
  return post('admin/commodity/auditLeifengReject', data)
}

// 获取活动列表
export function getLeifengActivityList(data) {
  return post('admin/commodity/getLeifengActivityList', data)
}

// 获取活动详情
export function getLeifengActivityDetail(data) {
  return post('admin/commodity/getLeifengActivityDetail', data)
}

// 活动审核通过
export function auditLeifengActivityPass(data) {
  return post('admin/commodity/auditLeifengActivityPass', data)
}

// 活动审核拒绝
export function auditLeifengActivityReject(data) {
  return post('admin/commodity/auditLeifengActivityReject', data)
}

// 获取订单列表
export function getOrderList(data) {
  return post('/admin/leifeng_order/orderList', data)
}

// 获取订单详情
export function getOrderDetail(data) {
  return post('/admin/leifeng_order/orderDetail', data)
}

// 订单发货
export function orderShip(data) {
  return post('/admin/leifeng_order/orderShip', data)
}

// 取消订单
export function cancelOrder(data) {
  return post('/admin/leifeng_order/cancelOrder', data)
}

// 删除订单
export function deleteOrder(data) {
  return post('/admin/leifeng_order/deleteOrder', data)
}

// 确认收货
export function confirmReceive(data) {
  return post('/admin/leifeng_order/confirmReceive', data)
}

// 批量发货
export function orderBatchShip(data) {
  return post('/admin/leifeng_order/orderBatchShip', data)
}